export default {
    driverPerformanceConfig_functions: "Functions",
     driverPerformanceConfig_dashboard: "Dashboard",   
}